export const Hoja = ({ eyebrow, title, subtitle, aside, children, testId }) => (
  <section
    data-testid={testId}
    className="settle bg-hoja border border-linea rounded-[24px] min-h-[60vh] lg:min-h-[calc(100vh-4rem)] p-5 sm:p-10 lg:px-14 lg:py-12"
  >
    <div className="flex flex-col sm:flex-row sm:items-start justify-between gap-4">
      <div className="min-w-0">
        {eyebrow && <p className="eyebrow mb-5">{eyebrow}</p>}
        <h1 className="font-serif text-4xl lg:text-[42px] text-tinta leading-tight first-letter:uppercase">{title}</h1>
        {subtitle && <p className="text-[15px] text-sec mt-1 first-letter:uppercase">{subtitle}</p>}
      </div>
      {aside}
    </div>
    <div className="mt-8">{children}</div>
  </section>
);
